/** 이 문서를 새로고침·뒤로·앞으로 가기로 다시 열었는지. 알 수 없으면 `false`. */
export function isDocumentReopen(): boolean {
  if (
    typeof performance === 'undefined' ||
    typeof performance.getEntriesByType !== 'function'
  ) {
    return false;
  }
  const [entry] = performance.getEntriesByType('navigation');
  if (!entry || !('type' in entry)) return false;
  return entry.type === 'reload' || entry.type === 'back_forward';
}
